import * as React from 'react';

/**
 * Icona co aria-label dinamico in base alla modalità di visualizzazione Mobile
 * per il componente ButtonResponsive
 */

export function getResponsiveButtonIcon(
  component?: React.ComponentType,
  ariaLabel?: string,
  isMobile?: boolean | null,
) {
  if (!component) return null;
  const IconComponent = component;

  const ariaProps = isMobile
    ? { 'aria-label': ariaLabel ?? '' }
    : { 'aria-hidden': true, 'aria-label': undefined };
  return <IconComponent {...ariaProps} />;
}
